import { connect } from "react-redux";
import { activateModal } from "../../common/UI/ActiveModal/duck/actions";
import { default as component } from "./CustomerProjectsCard.jsx";

const mapDispatchtoProps = {
  activateModal
};

export default connect(null, mapDispatchtoProps)(component);
